module.exports = __webpack_public_path__ + "static/media/checkmark.bf8ed1b3.svg";